import React, { useState } from 'react';
import { Button, Form, Modal, Row, Input, Col, message, Tag } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { PlusCircleOutlined, UserOutlined, SaveOutlined, AuditOutlined, UnlockOutlined } from '@ant-design/icons';
import Helmet from 'react-helmet';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import moment from 'moment';
import ZTable, { IFilterItem, ITableRef } from '@/components/ZTable';
import MainContent from '@/Layout/MainContent';
import { ApiSdk } from '../../httpclient';
import { VALIDATE_REQUIRED } from '../../constants';
import { formatDisplayFullDate2 } from '@/config';

type Props = {};

const filters: Array<IFilterItem> = [
  { type: 'TEXT', name: 'userName', label: 'staffSearch_accountId' },
  { type: 'TEXT', name: 'fullName', label: 'ガイド名' },
  { type: 'TEXT', name: 'email', label: 'メール' },
];

export default function LockedUsersPage({}: Props) {
  const history = useHistory();
  const [t] = useTranslation();
  const zTb = React.useRef<ITableRef>();

  const { columns } = React.useMemo(() => {
    const _columns: ColumnsType<any> = [
      {
        title: 'No.',
        width: 50,
        align: 'center',
        render: (v, r, i) => {
          return <b>{i + 1}</b>;
        },
      },
      { title: t('staffSearch_accountId'), width: 150, dataIndex: 'userName', sorter: true },
      { title: t('ガイド名'), width: 200, dataIndex: 'fullName', ellipsis: true },
      { title: t('メール'), width: 250, dataIndex: 'email', ellipsis: true },
      {
        title: '権限',
        dataIndex: 'roleClaims',
        ellipsis: true,
        render: (v: string[]) => v?.map(r => <Tag>{<Trans>{r}</Trans>}</Tag>),
      },
      {
        title: 'ロック自動解除日時',
        dataIndex: 'lockoutEnd',
        width: 160,
        ellipsis: true,
        render: formatDisplayFullDate2,
      },
    ];
    return { columns: _columns };
  }, [t]);

  const unLockAccount = (userId: string) => {
    ApiSdk.UserService.unlockUser({ id: userId }).then(() => {
      zTb.current?.reload();
    });
  };
  return (
    <MainContent title={t('menu.LockedUsers')} icon={<UserOutlined style={{ fontSize: 16 }} />}>
      <Helmet title={t('menu.LockedUsers')} />
      <div className="ant-layout-content-body">
        <ZTable<any>
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          url="/users/get-locked-users"
          bordered
          order_by="userName"
          order_by_asc={true}
          filters={filters}
          allowEdit={false}
          postMethod
          actionColumnWidth={150}
          extraActions={[
            {
              render: record => {
                return (
                  <Button
                    size="small"
                    danger
                    type="primary"
                    icon={<UnlockOutlined />}
                    onClick={() => {
                      unLockAccount(record.id);
                    }}
                  >
                    ロック解除
                  </Button>
                );
              },
            },
          ]}
        />
      </div>
    </MainContent>
  );
}
